import React, { FC } from 'react';
import { Button, Typography, ListItem, List, ListItemText, Box } from '@mui/material';
import DHDialog from 'components/shared/dh-dialog/dh-dialog.component';
import { useTranslation } from 'react-i18next';

type MissingCustomerNumberDialogProps = {
    open: boolean;
    onClose: () => void;
    clinicsWithoutCustomerNumber?: string[];
};
const MissingCustomerNumberDialog: FC<MissingCustomerNumberDialogProps> = ({
    open,
    onClose,
    clinicsWithoutCustomerNumber,
}: MissingCustomerNumberDialogProps) => {
    const { t: translate } = useTranslation(['common', 'invoices']);
    return (
        <DHDialog
            maxWidth="md"
            open={open}
            onClose={onClose}
            title={translate('invoices:MISSING_CUSTOMER_NUMBER')}
            actions={
                <Button key="close" onClick={onClose} data-test="missing-customer-number-dialog.close">
                    {translate('common:CLOSE')}
                </Button>
            }
        >
            <Box>
                {clinicsWithoutCustomerNumber?.length ? (
                    <Typography>{translate('invoices:MISSING_CUSTOMER_NUMBER_COLLECTIVE')}</Typography>
                ) : (
                    <Typography>{translate('invoices:MISSING_CUSTOMER_NUMBER_SINGLE')}</Typography>
                )}
            </Box>
            {clinicsWithoutCustomerNumber?.length ? (
                <Box>
                    <List>
                        {clinicsWithoutCustomerNumber.map((clinicName, index) => {
                            return (
                                <ListItem key={index}>
                                    <ListItemText primary={clinicName} />
                                </ListItem>
                            );
                        })}
                    </List>
                </Box>
            ) : undefined}
        </DHDialog>
    );
};

export default MissingCustomerNumberDialog;
